<template>
    <div class="form-item">
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value">
            <el-select size="small" style="width: 170px" :disabled="disabled" v-model="curValue" :filterable="filterable && !multiple" :multiple="multiple" :multipleLimit="multipleLimit" :collapseTags="collapseTags" clearable
                       @change="syncModel" @clear="doClear">
                <el-option v-for="dataItem in dataListInner" :key="dataItem[dataValue]" :label="dataItem[dataLabel]" :value="dataItem[dataValue]"></el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //有效的值类型
    let validValueTypes = ['Integer', 'String', 'Boolean'];

    function isValidValueType(valueType) {
        return validValueTypes.indexOf(valueType) != -1;
    }

    //转为指定的类型
    function castToTypedValue(srcValue, valueType) {
        let resultValue = srcValue;
        if(resultValue == null) {
            resultValue = null;
        }
        else {
            if(valueType == 'Integer') {
                resultValue = Utils.ParseInt(resultValue);
            }
            else if(valueType == 'Boolean') {
                resultValue = (resultValue + '') == 'true';
            }
            //String
        }
        return resultValue;
    }

    export default {
        name: 'swb-query-select-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'String'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            dataList: {//{ label, value }
                type: Array,
                default: []
            },
            dataLabel: {
                type: String,
                default: 'label'
            },
            dataValue: {
                type: String,
                default: 'value'
            },
            filterable: {//是否支持输入过滤条目（多选时不支持，因为导致界面错乱）
                type: Boolean,
                default: false
            },
            firstOnClear: {//清除后是否选中第一项
                type: Boolean,
                default: false
            },
            multiple: {//是否多选
                type: Boolean,
                default: false
            },
            multipleLimit: {//多选限制选择条目数
                type: Number,
                default: 0
            },
            firstIsMutex: {//多选的第一项是否与其他项互斥
                type: Boolean,
                default: false
            },
            collapseTags: {//多选时是否将选中值按文字的形式展示
                type: Boolean,
                default: true
            },
            iniValue: {
                default: null
            }
        },
        //
        data() {
            return {
                dataListInner: [],
                //
                curValue: null,
                //缓存第一值
                fstValue: null,
                //
                theCount: 0,
                theTimer: null,
                //上次选中项，用于比较第一值
                mulValues: []
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            dataList(newVal, oldVal) {
                this.init(this.curValue);
            },
            iniValue(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        destroyed() {
            clearTimeout(this.theTimer);
        },
        //
        methods: {
            init(oldValue) {
                if(!isValidValueType(this.valueType)) {
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if(typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    }
                    else {
                        MsgBox.error(message);
                    }
                }
                //
                this.fstValue = null;
                this.mulValues = [];
                clearTimeout(this.theTimer);
                //
                let valueType = this.valueType;
                let dataLabel = this.dataLabel;
                let dataValue = this.dataValue;
                //初始化
                let iniValue = null;
                if(this.multiple) {
                    let validValList = [];
                    this.dataListInner = this.dataList.map(function (item) {
                        let itemInner = {};
                        itemInner[dataLabel] = item[dataLabel];
                        itemInner[dataValue] = item[dataValue] == null ? null : castToTypedValue(item[dataValue], valueType);
                        validValList.push(itemInner[dataValue]);
                        return itemInner;
                    });
                    //
                    if(typeof oldValue == 'undefined') {
                        if(Utils.isArray(this.iniValue)) {
                            iniValue = Utils.copyAsArray(this.iniValue);
                        }
                        else {//处理单默认值问题
                            iniValue = castToTypedValue(this.iniValue, valueType);
                            if(validValList.indexOf(iniValue) == -1) {
                                iniValue = [];
                            }
                            else {
                                iniValue = [iniValue];
                            }
                        }
                    }
                    else {
                        iniValue = Utils.isArray(oldValue) ? oldValue : [];
                    }
                    //
                    this.theCount = this.dataListInner.length;
                    if(this.theCount > 0) {
                        this.fstValue = this.dataListInner[0][dataValue];
                    }
                    //过滤无效值
                    for(let i = iniValue.length - 1; i >= 0; i--) {
                        let tmpVal = castToTypedValue(iniValue[i], valueType);
                        if(validValList.indexOf(tmpVal) == -1) {
                            iniValue.removeAt(i);
                        }
                        else {
                            iniValue[i] = tmpVal;
                        }
                    }
                }
                else {
                    if(typeof oldValue == 'undefined') {
                        iniValue = this.iniValue == null ? null : (Utils.isArray(this.iniValue) ? null : this.iniValue);
                    }
                    else {
                        iniValue = oldValue;
                    }
                    iniValue = castToTypedValue(iniValue, valueType);
                    let iniValueFound = false;
                    this.dataListInner = this.dataList.map(function (item) {
                        let itemInner = {};
                        itemInner[dataLabel] = item[dataLabel];
                        itemInner[dataValue] = item[dataValue] == null ? null : castToTypedValue(item[dataValue], valueType);
                        //检查初始值
                        if(itemInner[dataValue] == iniValue) {
                            iniValueFound = true;
                        }
                        return itemInner;
                    });
                    //
                    this.theCount = this.dataListInner.length;
                    if(this.theCount > 0) {
                        this.fstValue = this.dataListInner[0][dataValue];
                    }
                    //
                    if(!iniValueFound) {
                        iniValue = null;
                    }
                }
                this.curValue = iniValue;
                //
                this.syncModel();
            },
            doClear() {
                clearTimeout(this.theTimer);
                //
                this.curValue = this.multiple ? [] : null;
                //
                this.syncModel();
            },
            handleMutexValues() {
                if(this.multiple && this.firstIsMutex && this.theCount > 0) {
                    let mulValues = this.mulValues;
                    let curValues = this.curValue;
                    if(mulValues.indexOf(this.fstValue) == -1 && curValues.indexOf(this.fstValue) != -1) {
                        //新选中了第一互斥项
                        this.curValue = [this.fstValue];//仅保留第一项
                    }
                    else if(mulValues.indexOf(this.fstValue) != -1) {
                        let fstIndex = curValues.indexOf(this.fstValue);
                        if(fstIndex != -1) {
                            this.curValue.removeAt(fstIndex);
                        }
                    }
                    this.mulValues = Utils.copyAsArray(this.curValue);
                }
            },
            syncModel() {
                this.handleMutexValues();
                //
                if(this.firstOnClear && this.theCount > 0) {
                    if(this.multiple) {
                        if(this.curValue.length == 0) {
                            this.curValue = [this.fstValue];
                        }
                    }
                    else {
                        if(this.curValue == null) {
                            this.curValue = this.fstValue;
                        }
                    }
                }
                //
                this.theTimer = setTimeout(this.syncModelInner, 50);
            },
            //
            syncModelInner() {
                let resultValue = this.curValue;
                if(resultValue != null) {//多选情况下不可能为null
                    if(this.multiple) {
                        resultValue = Utils.copyAsArray(this.curValue);
                    }
                }
                //
                this.$emit('input', resultValue);
                this.$emit('change', resultValue);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/query/QuerySelectField.vue